import { render, staticRenderFns } from "./teaPeiXunData.vue?vue&type=template&id=6b144c32"
import script from "./teaPeiXunData.vue?vue&type=script&lang=js"
export * from "./teaPeiXunData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports